import { useGetFeaturedProducts } from "@/api/queries";
import { Spinner } from "@/assets/icons";
import { ProductCard } from "@/components/atoms";
import { getProductAvailability } from "@/lib/utils";

export const TopSelling = () => {
  const { data, isFetching } = useGetFeaturedProducts();

  return (
    <section className='py-4 px-4 md:px-8 mb-2'>
      <div className='container mx-auto'>
        {/* Section header with "See All" button */}
        <div className='flex justify-between items-center mb-6'>
          <h2 className='text-2xl font-bold text-gray-800'>Our Featured Products</h2>
        </div>

        {isFetching ? (
          <div className='flex justify-center items-center py-8'>
            <Spinner />
          </div>
        ) : (
          <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4'>
            {data?.data?.map((product) => {
              const { hasStock, isUnlimited } = getProductAvailability(product);
              return (
                <ProductCard
                  key={product.id}
                  id={product.id}
                  name={product.name}
                  image={product.images[0]?.url || ""}
                  price={product.finalPrice}
                  oldPrice={product.basePrice}
                  hasStock={hasStock}
                  isUnlimited={isUnlimited}
                  sku={product.sku}
                  discount={product.discountPercentage}
                />
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};
